module.exports = __webpack_public_path__ + "static/media/88lotto-3x.75ce50a6.png";